// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Profile_wrapper__JZkBd"};